<header class="col-12 header-page">
  <h1 class="header__page__content__title">
    Meu Plano Pecúlio
  </h1>
</header>
<main class="main__content">
  <ng-template #notPeculio>
    <div class="row">
      <div class="col-md-12">
        <span class="informacao-no-guides">Você não possui Plano Pecúlio!</span>
      </div>
    </div>
  </ng-template>
  <section *ngIf="peculio; else notPeculio">
    <div class="card-peculio" *ngFor="let peculioUser of peculio; let i = index;">
      <div>
        <h2 *ngIf="i === 0" class="main__page__h2">{{peculioUser.tipoSegurado | titlecase}}</h2>
        <h2 *ngIf="i === 1" class="main__page__h2">{{peculioUser.tipoSegurado | titlecase}}</h2>
        <div class="col-xl-12 col-sm-12 col-md-12 col-lg-9 main__page__content__data__titular">
          <div>
            <b class="main__page__content__data__titular__title">Nome</b>
            <span>{{peculioUser.segurado}}</span>
          </div>
          <div>
            <b class="main__page__content__data__titular__title">Valor de Cobertura para Morte Natural</b>
            <span> {{peculioUser.valor | currency:'BRL'}}</span>
          </div>
          <div>
            <b class="main__page__content__data__titular__title">Valor de Cobertura para Morte Acidental</b>
            <span> {{ peculioUser.valorAcidental | currency:'BRL'}}</span>
          </div>
          <div>
            <b class="main__page__content__data__titular__title">Valor do prêmio Mensal</b>
            <span>{{peculioUser.premioMensal | currency:'BRL'}}</span>
          </div>
          <div>
            <b class="main__page__content__data__titular__title">Múltiplo</b>
            <span>{{peculioUser.multiplo}}</span>
          </div>
        </div>
      </div>
      <section class="d-flex content__header__table">
        <div class="col-xl-4">Beneficiário</div>
        <div class="col-xl-4">Parentesco</div>
        <div class="col-xl-4">% de cobertura</div>
      </section>
      <section>
        <div class="d-flex table__card" *ngFor="let beneficiario of peculioUser.beneficiarios">
          <div class="col-xl-4">{{beneficiario.beneficiario}}</div>
          <div class="col-xl-4">{{beneficiario.vinculoAfetivo}}</div>
          <div class="col-xl-4">{{beneficiario.porcentagem}}</div>
        </div>
      </section>
    </div>
  </section>
</main>
<footer>
</footer>